const Fonts = Object.freeze({
  regular: "var(--main-font)",
  black: "var(--title-font)",
});

export default Fonts;
